import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RebateClaimsHistoryModule } from './rebate-claims-history/rebate-claims-history.module'
import { CreateRebateClaimModule } from './create-rebate-claim/create-rebate-claim.module'
import { RebateClaimsDetailsModule } from './rebate-claims-details/rebate-claims-details.module'

@NgModule({
  declarations: [],
  imports: [CommonModule, CreateRebateClaimModule, RebateClaimsHistoryModule, RebateClaimsDetailsModule]
})
export class RebateClaimsModule {}
